import { mediaUrl } from "./siteUtils";

export const SiteImage = ({ image, id, className = "", eager = false, admin = false }) => {
  const primary = image?.desktop || image?.mobile;
  if (!primary || (!image.active && !admin)) return null;

  return <figure className={`site-picture ${className}`} style={{ "--focal": `${image.focal_x}% ${image.focal_y}%`, "--mobile-focal": `${image.mobile_focal_x}% ${image.mobile_focal_y}%`, "--image-fit": image.fit || "cover" }} data-testid={`${id}-picture`}><picture>
    {image.mobile && <source media="(max-width: 767px)" srcSet={mediaUrl(image.mobile, admin)} />}
    <img
      src={mediaUrl(primary, admin)}
      alt={image.alt || ""}
      loading={eager ? "eager" : "lazy"}
      fetchpriority={eager ? "high" : "auto"}
      data-testid={`${id}-image`}
    />
  </picture>{image.illustrative && <figcaption className="site-illustrative-label" data-testid={`${id}-illustrative`}>Imagem ilustrativa</figcaption>}</figure>;
};
